import {
  Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges, AfterViewInit,
  ChangeDetectorRef, NgZone
} from '@angular/core';
import {
  ControlContainer, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup,
  FormGroupDirective, Validators, FormArray, UntypedFormArray
} from '@angular/forms';
import { SelectBox, TimeApiService } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  ResponseCommon, GeneralSystemConstInfoCacheDto,
  Szma102aRequest, Szma103aRequest, Szma103aResponseElecCtrSearchResultDto,
  Szma103aCustomResponse, Szma301aResponseGasCtrSearchResultDto, Szma301aCustomResponse,
  Szma301aResponseFtiGoodsMst, Szma103aResFtiGoodsDto, Sgkb981aFtiGoodsDto,
  CodeConversionMstDto,
  Sgkb991aRequest, Sgkb991aResponse, Sgkb991aResBushoInfoDto,
  Sgkb992aRequest, Sgkb992aResponse, Sgkb992aResStaffInfoDto
} from 'sg-api';
import { UsedSzma102aService } from '../../../../../sg-kb-shared/services/used-szma102a.service';
import { UsedSzma103aService } from '../../../../../sg-kb-shared/services/used-szma103a.service';
import { UsedSzma301aService } from '../../../../../sg-kb-shared/services/used-szma301a.service';
import { UsedSgkb981aService } from '../../services/used-sgkb981a.service';
import { UsedSgkb991aService } from '../../services/used-sgkb991a.service';
import { UsedSgkb992aService } from '../../services/used-sgkb992a.service';
import { MoneyFormatService } from '../../../../../../sg-base/sg-base-shared/services/money-format.service';
import { GeneralSystemConstInfoMstService } from '../../../../../../sg-base/sg-base-shared/services/generalSystemConstInfoMst.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CompleteDataService } from '../../../../../../sg-base/sg-base-shared/pages/sgkz003d/services/complete-data.service';
import { SgkbConstains } from '../../../../../sg-kb-shared/sg-kb-constans';

const ServiceType = {
  Gas: 'gas',
  Electric: 'electric',
} as const;
type ServiceType = typeof ServiceType[keyof typeof ServiceType];

const PrdCodeType = {
  BasiCtr: 'basiCtr',
  Oguchi: 'oguchi',
  Ather: 'ather',
} as const;
type PrdCodeType = typeof PrdCodeType[keyof typeof PrdCodeType];

@Component({
  selector: 'app-sgkb980d-input',
  templateUrl: './sgkb980d-input.component.html',
  styleUrl: './sgkb980d-input.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  providers: [],
})
export class Sgkb980dInputComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {

  /** 親コンポーネント保持領域 */
  parentForm: UntypedFormGroup | null = null;

  /** 契約修正情報格納FormGroup*/
  contModInputChildForm: UntypedFormGroup;

  private onDestroy$ = new Subject();

  /** コードマスタ取得 */
  @Input() codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;

  /** 契約情報 */
  /** 契約担当部署 */
  contractDepartmentCategory: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 契約担当者 */
  contractManagerCategory: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** お客さま担当部署 */
  customerDepartment: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** お客さま担当者 */
  customerManager: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 契約開始日 */
  appliStartDate: UntypedFormControl =
    new UntypedFormControl({ value: new Date(null), disabled: false }, Validators.required);
  /** 初回検針年月 */
  firstMeterReadMon: UntypedFormControl =
    new UntypedFormControl({ value: new Date(null), disabled: false }, Validators.required);
  /** 契約満了年月 */
  expirationMon: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: true }, Validators.required);
  /** 契約終了日 */
  appliEndDate: UntypedFormControl =
    new UntypedFormControl({ value: new Date(null), disabled: true });
  /** 独自管理対象個別コード */
  IndManageSign: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 冷房能力 */
  coolAbility: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 発電容量 */
  generatCapacity: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 定格入力値（合計） */
  preRatedInputValue: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 停止時要配慮フラグ */
  attentionOnStopFlagCategory: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 関連会社区分 */
  kanrengaisyaCategory: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 関連会社お客さま番号 */
  kanrengaisyaOkyakusamaNo: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 契約お客さま番号（hidden） */
  firstSrvctrNo: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** サービス契約番号（hidden） */
  srvCtrNo: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 更新通番号（hidden） */
  updateSrno: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });

  /** 契約書情報 */
  /** 契約締結日 */
  agreementDate: UntypedFormControl =
    new UntypedFormControl({ value: new Date(null), disabled: false });
  /** 契約書受領日 */
  receiptDate: UntypedFormControl =
    new UntypedFormControl({ value: new Date(null), disabled: false });
  /** 基本契約締結日 */
  basicAgreementDate: UntypedFormControl =
    new UntypedFormControl({ value: new Date(null), disabled: false });
  /** 基本契約書受領日 */
  basicReceiptDate: UntypedFormControl =
    new UntypedFormControl({ value: new Date(null), disabled: false });

  // 契約担当部署のセレクトボックスデータ
  contractDepartmentList: SelectBox[] = [];

  // 契約担当者のセレクトボックスデータ
  contractManagerList: SelectBox[] = [];

  /** 冷房能力（カンマ編集） */
  readonly constNumberCommaMaxLength1: number = 8;
  numberCommaMaxLength1: number = this.constNumberCommaMaxLength1;
  /** 発電容量（カンマ編集） */
  readonly constNumberCommaMaxLength2: number = 7;
  numberCommaMaxLength2: number = this.constNumberCommaMaxLength2;
  /** 定格入力値（合計）（カンマ編集） */
  readonly constNumberCommaMaxLength3: number = 8;
  numberCommaMaxLength3: number = this.constNumberCommaMaxLength3;

  // 部署コード
  bushoCode: string = "";

  /** 画面パラメータ */
  /** 遷移元ステータス */
  paraModifyType: string;
  /** 契約お客さま番号 */
  paraFirstSrvctrNo: string;

  /** APIレスポンスデータ */
  /** 契約情報取得（電気） 共通エリア */
  szma103aResCommon: ResponseCommon;
  /** 契約情報取得（電気） 共通エリア＞カスタマイズ */
  szma103aResCustomize: Szma103aCustomResponse;
  /** 契約情報取得（電気） 契約共通情報 */
  szma103aResElecCtrSearchResultDto: Szma103aResponseElecCtrSearchResultDto;

  /** 契約情報取得（ガス） 共通エリア */
  szma301aResCommon: ResponseCommon;
  /** 契約情報取得（ガス） 共通エリア＞カスタマイズ */
  szma301aResCustomize: Szma301aCustomResponse;
  /** 契約情報取得（ガス） 契約共通情報 */
  szma301aResGasCtrSearchResultDto: Szma301aResponseGasCtrSearchResultDto;

  /** 部署情報検索結果 */
  sgkb991aResponse: Sgkb991aResponse;
  /** responseCommon(SGKB991A) */
  sgkb991aResponseCommon: ResponseCommon;
  /** 部署情報リスト */
  bushoInfoList: Array<Sgkb991aResBushoInfoDto>;

  /** 社員情報検索結果 */
  sgkb992aResponse: Sgkb992aResponse;
  /** responseCommon(SGKB992A) */
  sgkb992aResponseCommon: ResponseCommon;
  /** 社員情報リスト */
  staffInfoList: Array<Sgkb992aResStaffInfoDto>;

  /** 付帯契約情報（画面表示用）Dto */
  dispFtiGoodsList: Sgkb981aFtiGoodsDto[];

  /** 画面項目の編集変数 */
  /** サービス種別コード（画面表示判定） */
  dispSrvClsfyCode: string;
  /** プロダクト種別区分コード（画面表示判定：業務用大口） */
  dispPrdClsfyDiv: string;
  /** プロダクト種別区分コード（画面表示判定：ガス契約） */
  dispPrdClsfyDivGas: string;
  /** プロダクト種別区分コード（画面表示判定：ガス契約） */
  dispChoukiWaribiki: string;
  /** コード変換マスタから受け取る停止時要配慮フラグのセレクトボックスデータ */
  preAttentionOnStopFlagList: SelectBox[] = [];
  /** コード変換マスタから受け取る関連会社区分のセレクトボックスデータ */
  preKanrengaisyaList: SelectBox[] = [];
  /** 停止時要配慮フラグのセレクトボックス */
  attentionOnStopFlagList: SelectBox[] = [];
  /** 関連会社区分のセレクトボックスデータ */
  kanrengaisyaList: SelectBox[] = [];
  /** 付帯商品情報表示フラグ */
  dispFtiGoods: boolean = false;
  /** 汎用システム定数情報（長期割引） */
  sysDefCodeSGKB0003List: Array<GeneralSystemConstInfoCacheDto>;
  /** 汎用システム定数情報（契約修正対象） */
  sysDefCodeSGKB0001List: Array<GeneralSystemConstInfoCacheDto>;
  /** 汎用システム定数情報（ガス契約の契約修正対象） */
  sysDefCodeSGKB0040List: Array<GeneralSystemConstInfoCacheDto>;

  /**
   * コンストラクタ
   */
  constructor(private router: Router, private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private parent: FormGroupDirective,
    private usedSzma102aService: UsedSzma102aService,
    private usedSzma103aService: UsedSzma103aService,
    private usedSzma301aService: UsedSzma301aService,
    private usedsgkb981aService: UsedSgkb981aService,
    private moneyFormatService: MoneyFormatService,
    private timeApiService: TimeApiService,
    private completeDataService: CompleteDataService,
    private generalSystemConstInfoMstService: GeneralSystemConstInfoMstService,
    private usedSgkb991aService: UsedSgkb991aService,
    private usedSgkb992aService: UsedSgkb992aService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
  ) {
    this.parentForm = this.fb.group({});
    // 画面遷移時のパラメータ取得
    // 遷移元ステータス  1：「契約内容修正」ボタン押下、2：「契約付帯情報登録」ボタン押下
    this.paraModifyType = this.route.snapshot.paramMap.get('modifyType');
    // 契約お客さま番号
    this.paraFirstSrvctrNo = this.route.snapshot.paramMap.get('firstSrvctrNo');
  }

  ngAfterViewInit(): void {
    // 非同期処理の変更点を制御（ExpressionChangedAfterItHasBeenCheckedErrorの回避）
    this.ngZone.run(() => {
      // 自コンポーネント内のフォーム状態を最新化
      this.parentForm.updateValueAndValidity();
      this.contModInputChildForm.updateValueAndValidity();
      // 変更検出を行い、ビューとデータの整合性を確保
      this.cdr.detectChanges();
    });
  }

  /**
   * 初期化処理
   * @memberof Sgkb980dInputComponent
   */
  ngOnInit(): void {

    // 修正情報
    this.contModInputChildForm = this.fb.group({
      contractDepartmentCategory: this.contractDepartmentCategory,
      contractManagerCategory: this.contractManagerCategory,
      customerDepartment: this.customerDepartment,
      customerManager: this.customerManager,
      appliStartDate: this.appliStartDate,
      firstMeterReadMon: this.firstMeterReadMon,
      expirationMon: this.expirationMon,
      appliEndDate: this.appliEndDate,
      IndManageSign: this.IndManageSign,
      coolAbility: this.coolAbility,
      generatCapacity: this.generatCapacity,
      preRatedInputValue: this.preRatedInputValue,
      airControlFlg: this.fb.control({ value: false, disabled: false }),
      deviceFlg: this.fb.control({ value: false, disabled: false }),
      attentionOnStopFlagCategory: this.attentionOnStopFlagCategory,
      noticeOfAdjustmentUnitChargeIssueFlg: this.fb.control({ value: false, disabled: false }),
      kanrengaisyaCategory: this.kanrengaisyaCategory,
      kanrengaisyaOkyakusamaNo: this.kanrengaisyaOkyakusamaNo,
      firstSrvctrNo: this.firstSrvctrNo,
      srvCtrNo: this.srvCtrNo,
      updateSrno: this.updateSrno,
      agreementDate: this.agreementDate,
      receiptDate: this.receiptDate,
      basicAgreementDate: this.basicAgreementDate,
      basicReceiptDate: this.basicReceiptDate,
      items: this.fb.array([]),
    });

    if (this.parent.form != null) {
      this.parentForm = this.parent.form;
      this.parentForm.addControl('contModInputChildForm', this.contModInputChildForm);
    }

    // 汎用システム定義を取得
    let sysDefCodeList: Array<string> = [];
    sysDefCodeList.push('SGKB0003');
    sysDefCodeList.push('SGKB0001');
    sysDefCodeList.push('SGKB0040');
    this.generalSystemConstInfoMstService.getGeneralSystemConstInfoMst(sysDefCodeList)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(sysDefCodeMap => {
        this.sysDefCodeSGKB0003List = Array.from(new Set(sysDefCodeMap.get('SGKB0003')));
        this.sysDefCodeSGKB0001List = Array.from(new Set(sysDefCodeMap.get('SGKB0001')));
        this.sysDefCodeSGKB0040List = Array.from(new Set(sysDefCodeMap.get('SGKB0040')));
      });

    // 契約検索・一覧照会リクエストを作成
    const szma102aRequest: Szma102aRequest = {
      ctrSearchInfo: {
        firstSrvctrNoList: [this.paraFirstSrvctrNo],
        ctrStatus: '2', // 歴面は不要であるため、「満了した契約（最新のみ）も含む」で取得
      }
    };
    // 契約検索・一覧照会 API呼出し
    this.usedSzma102aService.searchContractor(szma102aRequest, true)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        const serviceType: ServiceType = this.judgeServiceType(
          response.ctrSearchResultList[0].ctrCommonMstInfo.srvClsfyCode);
        // サービス種別コードが「電気」の場合
        if (serviceType == ServiceType.Electric) {
          const szma103aRequest: Szma103aRequest = {
            ctrSearchInfo: {
              srvCtrNo: response.ctrSearchResultList[0].ctrCommonMstInfo.srvCtrNo,
            }
          };
          // 変更検出を行い、ビューとデータの整合性を確保
          this.cdr.detectChanges();
          // 契約情報取得（電気）API呼出し
          this.usedSzma103aService.searchContractor(szma103aRequest)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(response => {
              // 契約情報取得（電気） 共通エリア
              this.szma103aResCommon = response.responseCommon;
              // 契約情報取得（電気） 共通エリア＞カスタマイズ
              this.szma103aResCustomize = (<Szma103aCustomResponse>response.responseCommon.responseCustomize);
              // 契約情報取得（電気） 契約共通情報
              this.szma103aResElecCtrSearchResultDto = response.elecCtrSearchResultDto;
              // プロダクト種別区分を基に業務用大口を判定
              const prdCodeType: PrdCodeType = this.judgePrdCodeType(
                this.szma103aResElecCtrSearchResultDto.ctrCommonMstInfo.prdClsfyDiv,
                this.szma103aResCustomize.ctrCommonInfo.basiccontractdocumentNo);
              // 部署情報取得API実行
              this.executeSgkb991A(this.szma103aResCustomize.ctrCommonInfo.companygroupcode,
                this.szma103aResCustomize.ctrCommonInfo.companycode,
                this.szma103aResCustomize.ctrCommonInfo.ctrTantoSskno
              );
              // 社員情報取得API実行
              this.executeSgkb992A(this.szma103aResCustomize.ctrCommonInfo.ctrTantoSskno,
                this.szma103aResCustomize.ctrCommonInfo.tantoPrivateid
              );
              // 画面項目設定
              this.setInitializeData(serviceType, prdCodeType);
              // 変更検出を行い、ビューとデータの整合性を確保
              this.cdr.detectChanges();
            }
            );
          return;
        }
        // サービス種別コードが「ガス」の場合
        else if (serviceType == ServiceType.Gas) {
          // 契約情報取得（ガス）API呼び出し
          this.usedSzma301aService.searchContractor(
            response.ctrSearchResultList[0].ctrCommonMstInfo.srvCtrNo)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(response => {
              // 契約情報取得（ガス） 共通エリア
              this.szma301aResCommon = response.responseCommon;
              // 契約情報取得（ガス） 共通エリア＞カスタマイズ
              this.szma301aResCustomize = (<Szma301aCustomResponse>response.responseCommon.responseCustomize);
              // 契約情報取得（ガス） 契約共通情報
              this.szma301aResGasCtrSearchResultDto = response.gasCtrSearchResultDto;
              // プロダクト種別区分を基に業務用大口を判定
              const prdCodeType: PrdCodeType = this.judgePrdCodeType(
                this.szma301aResGasCtrSearchResultDto.ctrCommonMstInfo.prdClsfyDiv,
                this.szma301aResCustomize.ctrCommonInfo.basiccontractdocumentNo);
              // 部署情報取得API実行
              this.executeSgkb991A(this.szma301aResCustomize.ctrCommonInfo.companygroupcode,
                this.szma301aResCustomize.ctrCommonInfo.companycode,
                this.szma301aResCustomize.ctrCommonInfo.ctrTantoSskno
              );
              // 社員情報取得API実行
              this.executeSgkb992A(this.szma301aResCustomize.ctrCommonInfo.ctrTantoSskno,
                this.szma301aResCustomize.ctrCommonInfo.tantoPrivateid
              );
              //画面項目設定
              this.setInitializeData(serviceType, prdCodeType);
              // 変更検出を行い、ビューとデータの整合性を確保
              this.cdr.detectChanges();
            }

            );
          return;
        }
        // 変更検出を行い、ビューとデータの整合性を確保
        this.cdr.detectChanges();
      });
  }

  /**
   * @Inputプロパティが変更されたときに、その変更に関する情報を提供
   * @param {SimpleChanges} changes
   * @returns 
   */
  ngOnChanges(changes: SimpleChanges) {
    // 対象プロパティが変更された場合のみ処理する
    if (changes.codeConversionMstMap && this.codeConversionMstMap) {
      // コードS001000 のリスト取得
      this.preAttentionOnStopFlagList.push(...this.getSelectBoxFromCodeConversionMst('S001000'));
      // コードS001800 のリスト取得
      this.preKanrengaisyaList.push(...this.getSelectBoxFromCodeConversionMst('S001800'));
    }
  }

  /**
   * サービス種別コードからサービス種別を判定
   * 01:ガス
   * 11:電気
   * @param srvClsfyCode 
   * @returns 
   */
  judgeServiceType(srvClsfyCode: string): ServiceType {
    switch (srvClsfyCode) {
      case SgkbConstains.CODE.SERVICE_CLY_CD.GAS:
        // 画面受け渡し変数の設定
        this.dispSrvClsfyCode = ServiceType.Gas;
        return ServiceType.Gas;
      case SgkbConstains.CODE.SERVICE_CLY_CD.ELE:
        // 画面受け渡し変数の設定
        this.dispSrvClsfyCode = ServiceType.Electric;
        return ServiceType.Electric;
    }
  }

  /**
   * プロダクト種別区分から業務用大口を判定
   * @param prdClsfyDiv 
   * @returns 
   */
  judgePrdCodeType(prdClsfyDiv: string, basiccontractdocumentNo: string): PrdCodeType {
    if (basiccontractdocumentNo && basiccontractdocumentNo != '') {
      // 画面受け渡し変数の設定
      this.dispPrdClsfyDiv = PrdCodeType.BasiCtr;
      return PrdCodeType.BasiCtr;
    } else if (prdClsfyDiv == SgkbConstains.CODE.PRDCT_CLY_DIV_CD.BIZTERMS_APPFORM
      || prdClsfyDiv == SgkbConstains.CODE.PRDCT_CLY_DIV_CD.BIZFORM_APPLY
      || prdClsfyDiv == SgkbConstains.CODE.PRDCT_CLY_DIV_CD.BIZTERMS_CONTRACT
      || prdClsfyDiv == SgkbConstains.CODE.PRDCT_CLY_DIV_CD.LARGESUPPLY
      || prdClsfyDiv == SgkbConstains.CODE.PRDCT_CLY_DIV_CD.HIGHVOLT_BELOW500KW
      || prdClsfyDiv == SgkbConstains.CODE.PRDCT_CLY_DIV_CD.HIGHVOLT_ABOVE500KW
      || prdClsfyDiv == SgkbConstains.CODE.PRDCT_CLY_DIV_CD.SPECIAL_HIGHVOLTAGE) {
      // 画面受け渡し変数の設定
      this.dispPrdClsfyDiv = PrdCodeType.Oguchi;
      return PrdCodeType.Oguchi;
    } else {
      // 画面受け渡し変数の設定
      this.dispPrdClsfyDiv = PrdCodeType.Ather;
      return PrdCodeType.Ather;
    }
  }

  /**
   * セレクトボックスの自動生成
   * @param codeId 
   * @memberof Sgkb980dInputComponent
   * @returns 
   */
  getSelectBoxFromCodeConversionMst(codeId: string): SelectBox[] {
    let retSelectBoxList: SelectBox[] = [];
    let codeList: CodeConversionMstDto[] = [];
    if (this.codeConversionMstMap.has(codeId)) {
      codeList = this.codeConversionMstMap.get(codeId);
      if (codeList) {
        codeList.forEach(data => {
          const select: SelectBox = { value: data.userCode, viewValue: data.hyojiCont };
          retSelectBoxList.push(select);
        })
      }
    }
    return retSelectBoxList;
  }

  /** 
   * セレクトボックスの初期選択値を設定
   * @memberof Sgkb980dInputComponent
   */
  setSelectBoxData(target: string, codeList: Array<SelectBox>): SelectBox[] {

    let selectBox: SelectBox[]

    selectBox = codeList.map(data => ({
      value: data.value,
      viewValue: data.viewValue,
    }))
    return selectBox;
  }

  /**
 * 画面初期表示値の設定
 * @param srvClsfyCode 
 * @memberof Sgkb980dInputComponent
 */
  setInitializeData(serviceType: ServiceType, prdCodeType: PrdCodeType): void {
    // サービス種別コードが「ガス」の場合
    if (serviceType == ServiceType.Gas) {
      // 画面の値を設定 
      this.setDispValue(this.szma301aResGasCtrSearchResultDto, this.szma301aResCustomize,
        serviceType, prdCodeType);
      // 付帯商品情報の設定
      this.setDispFtiGoodsInfo(this.szma301aResGasCtrSearchResultDto, this.szma301aResCustomize);
    }

    // サービス種別コードが「電気」の場合
    if (serviceType == ServiceType.Electric) {
      // 画面の値を設定 
      this.setDispValue(this.szma103aResElecCtrSearchResultDto, this.szma103aResCustomize,
        serviceType, prdCodeType);
      // 付帯商品情報の設定
      this.setDispFtiGoodsInfo(this.szma103aResElecCtrSearchResultDto, this.szma103aResCustomize);
    }

    // 活性・非活性制御
    // 「契約内容修正」ボタンからの遷移の場合
    if (this.paraModifyType === '1') {
      // 契約開始日
      this.contModInputChildForm.controls['appliStartDate'].enable();
      // 初回検針年月
      this.contModInputChildForm.controls['firstMeterReadMon'].enable();

      for (let i = 0; i < this.items.length; i++) {
        // 付帯契約情報のフォームを取得
        const itemsForm = this.items.at(i) as UntypedFormArray;
        // 適用開始日
        itemsForm.controls['opeStartMonth'].enable();
        // 満了予定年月
        itemsForm.controls['expScheduleMonth'].enable();
      }
    }
    // 「契約付帯情報登録」ボタンからの遷移の場合
    else if (this.paraModifyType === '2') {
      // 契約開始日
      this.contModInputChildForm.controls['appliStartDate'].disable();
      // 初回検針年月
      this.contModInputChildForm.controls['firstMeterReadMon'].disable();

      for (let i = 0; i < this.items.length; i++) {
        // 付帯契約情報のフォームを取得
        const itemsForm = this.items.at(i) as UntypedFormArray;
        // 適用開始日
        itemsForm.controls['opeStartMonth'].disable();
        // 満了予定年月
        itemsForm.controls['expScheduleMonth'].disable();
        // 付帯契約の継続年数
        itemsForm.controls['continuYears'].disable();
      }
    }
  }

  /**
   * 画面の値を設定する処理
   * @memberof Sgkb980dInputComponent
   */
  setDispValue(gyomuDate: any, customDate: any, serviceType: ServiceType, prdCodeType: PrdCodeType): void {
    // お客さま担当部署
    this.contModInputChildForm.controls['customerDepartment'].setValue(
      customDate.ctrCommonInfo.visitMadoguchiTantobusho);
    // お客さま担当者
    this.contModInputChildForm.controls['customerManager'].setValue(
      customDate.ctrCommonInfo.visitMadoguchiTntsh);
    // 契約開始日
    this.contModInputChildForm.controls['appliStartDate'].setValue(
      this.timeApiService.convertStringToDate(gyomuDate.ctrCommonMstInfo.ctrStrtdt));
    // 初回検針年月
    this.contModInputChildForm.controls['firstMeterReadMon'].setValue(
      this.convertToYyyyMmAddHyphen(customDate.ctrCommonInfo.firstInspectionyearmonthday));
    // 契約満了年月
    this.contModInputChildForm.controls['expirationMon'].setValue(
      this.convertToYyyyMm(gyomuDate.hontiGoodsInfo.ctrExpireDate));
    // 契約終了日
    this.contModInputChildForm.controls['appliEndDate'].setValue(
      this.timeApiService.convertStringToDate(gyomuDate.ctrCommonMstInfo.ctrEnddt));
    // 独自管理対象個別コード
    this.contModInputChildForm.controls['IndManageSign'].setValue(
      customDate.ctrCommonInfo.independentmanagementTargetIndividualcode);

    // サービス種別コードが「ガス」の場合
    if (serviceType == ServiceType.Gas) {

      // 汎用システム定義からガス契約で契約修正対象のプロダクト種別区分が一致する情報を取り出す
      const sysDefCode = this.sysDefCodeSGKB0040List.find(
        sysDefCode => sysDefCode.settingValueText === gyomuDate.ctrCommonMstInfo.prdClsfyDiv);

      if (sysDefCode && sysDefCode != null) {
        this.dispPrdClsfyDivGas = 'on';
        // 空調チェックボックス
        if (customDate.gasConInfo.airconditioningTargetflag === '1') {
          this.contModInputChildForm.controls['airControlFlg'].setValue(true)
        }
        // 機器定格チェックボックス
        if (customDate.gasConInfo.kikirateTargetflag === '1') {
          this.contModInputChildForm.controls['deviceFlg'].setValue(true)
        }
      } else {
        this.dispPrdClsfyDivGas = 'off';
      }

      // 冷房能力
      this.contModInputChildForm.controls['coolAbility'].setValue(
        this.szma301aResCustomize.gasConInfo.reiboability);
      // カンマ編集のためフォーカスアウト時の処理を実行
      this.onBlurNumberComma('coolAbility');
      // 発電容量
      this.contModInputChildForm.controls['generatCapacity'].setValue(
        this.szma301aResCustomize.gasConInfo.powergenerationcapacity);
      // カンマ編集のためフォーカスアウト時の処理を実行
      this.onBlurNumberComma('generatCapacity');
      // 定格入力値（合計）
      this.contModInputChildForm.controls['preRatedInputValue'].setValue(
        this.szma301aResCustomize.gasConInfo.ratedinputvalueSum);
      // カンマ編集のためフォーカスアウト時の処理を実行
      this.onBlurNumberComma('preRatedInputValue');
    }

    // 調整単位料金おしらせ発行フラグ
    if (customDate.ctrCommonInfo.adjustmentunitfeeNoticeHakkoflag === SgkbConstains.CODE.ADJUST_UNIT_FEE_NTC_HAKKO_FLG.ISSUE) {
      this.contModInputChildForm.controls['noticeOfAdjustmentUnitChargeIssueFlg'].setValue(true)
    }

    // サービス種別コードが「電気」の場合
    if (serviceType == ServiceType.Electric) {
      // 停止時要配慮フラグの必須バリデータ設定
      this.attentionOnStopFlagCategory.setValidators(Validators.required);
      // 停止時要配慮フラグのセレクトボックスにデータを設定
      this.attentionOnStopFlagList = this.setSelectBoxData(
        customDate.ctrCommonInfo.duringstopAttentionrequiredflag,
        this.preAttentionOnStopFlagList);
      // 停止時要配慮フラグのセレクトボックスを選択状態にする
      this.attentionOnStopFlagCategory.setValue(
        customDate.ctrCommonInfo.duringstopAttentionrequiredflag);
      // 関連会社区分のセレクトボックスにデータを設定
      this.kanrengaisyaList = this.setSelectBoxData(
        customDate.elecCtrInfo.relatedcompanyDiv,
        this.preKanrengaisyaList);
      // 関連会社区分のセレクトボックスを選択状態にする
      this.kanrengaisyaCategory.setValue(
        customDate.elecCtrInfo.relatedcompanyDiv);
      // 関連会社お客さま番号
      this.contModInputChildForm.controls['kanrengaisyaOkyakusamaNo'].setValue(
        customDate.elecCtrInfo.relatedcompanyVisitornumber);
    }

    // 契約お客さま番号（hidden）
    this.contModInputChildForm.controls['firstSrvctrNo'].setValue(
      gyomuDate.ctrCommonMstInfo.firstSrvctrNo);
    // サービス契約番号（hidden）
    this.contModInputChildForm.controls['srvCtrNo'].setValue(
      gyomuDate.ctrCommonMstInfo.srvCtrNo);
    // 更新通番号（hidden）
    this.contModInputChildForm.controls['updateSrno'].setValue(
      customDate.ctrCommonInfo.updateSrno);

    // 契約締結日
    this.contModInputChildForm.controls['agreementDate'].setValue(
      this.timeApiService.convertStringToDate(gyomuDate.ctrCommonMstInfo.prdCtrDate));
    // 契約書受領日
    this.contModInputChildForm.controls['receiptDate'].setValue(
      this.timeApiService.convertStringToDate(
        customDate.ctrCommonInfo.ctrdocReceiptdate));
    // 基本契約締結日
    this.contModInputChildForm.controls['basicAgreementDate'].setValue(
      this.timeApiService.convertStringToDate(
        customDate.ctrCommonInfo.basiccontractConclusiondate));
    // 基本契約書受領日
    this.contModInputChildForm.controls['basicReceiptDate'].setValue(
      this.timeApiService.convertStringToDate(
        customDate.ctrCommonInfo.basiccontractdocumentReceiptdate));
    // 変更検出を行い、ビューとデータの整合性を確保
    this.cdr.detectChanges();
  }

  /**
   * 付帯契約情報の処理
   * @memberof Sgkb980dInputComponent
   */
  setDispFtiGoodsInfo(gyomuDate: any, customDate: any): void {

    // 付帯商品契約情報がない場合、付帯商品情報を非表示にし、処理を終了
    if (gyomuDate.ftiGoodsMstInfo.ftiGoodsMstList.length == 0) {
      this.dispFtiGoods = false;
      return;
    } else {
      this.dispFtiGoods = true;
    }

    // レスポンス情報の取得
    const ftiGoodsMstList: Array<Szma301aResponseFtiGoodsMst> =
      gyomuDate.ftiGoodsMstInfo.ftiGoodsMstList;
    const ftiGoodsListCostam: Array<Szma103aResFtiGoodsDto> =
      customDate.ftiGoodsInfo.ftiGoodsList;

    // 付帯契約情報の編集用リスト
    let setFtiGoodsList: Array<Sgkb981aFtiGoodsDto> = [];

    // レスポンス情報を付帯契約情報の編集用リストに設定
    ftiGoodsMstList.forEach((ftiGoods) => {
      // カスタマイズエリアから商品コードが一致するレコードを取り出す
      const ftiGoodsCostam = ftiGoodsListCostam.find(
        ftiGoodsCostam => ftiGoodsCostam.goodsCode === ftiGoods.goodsCode);

      // 汎用システム定義から契約修正対象の商品コードが一致する情報を取り出す
      const sysDefCode = this.sysDefCodeSGKB0001List.find(
        getList => getList.settingValueText === ftiGoods.goodsCode);

      // 汎用システム定義に該当する商品コードがある場合
      if (sysDefCode && sysDefCode != null) {
        let setFtiGoods: Sgkb981aFtiGoodsDto = {
          // 商品コード
          goodsCode: ftiGoods.goodsCode,
          // 商品契約利用開始日付
          useStartDate: ftiGoodsCostam.futaiCtrStartdate,
          // 商品契約満了予定日付
          ctrExpireDate: ftiGoods.ctrExpireDate,
          // プロダクト商品画面用名称
          prdGoodsDisp: ftiGoods.prdGoodsDisp,
          // 継続年数
          duration: ftiGoodsCostam.duration,
        }
        setFtiGoodsList.push(setFtiGoods);
      }
    });
    // 付帯契約情報の編集用リストを付帯契約情報（画面表示用）リストに設定
    this.dispFtiGoodsList = Array.from(new Set(setFtiGoodsList));

    // 付帯契約情報（画面表示用）リストがゼロ件の場合、付帯契約情報を非表示にし、処理を終了
    if (this.dispFtiGoodsList.length == 0) {
      this.dispFtiGoods = false;
      return;
    } else {
      this.dispFtiGoods = true;
    }

    // フォームから付帯商品情報リストを抽出
    const itemsList = this.contModInputChildForm.get('items') as UntypedFormArray;
    this.dispFtiGoodsList.forEach((dispFtiGoods) => {
      // 汎用システム定義から長期割引の商品コードが一致する情報を取り出す
      const sysDefCode = this.sysDefCodeSGKB0003List.find(
        getList => getList.settingValueText === dispFtiGoods.goodsCode);

      let dispFlg: boolean = false;
      if (sysDefCode && sysDefCode != null) {
        // 継続年数（表示）
        dispFlg = true;
      } else {
        // 継続年数（非表示）
        dispFlg = false;
      }

      itemsList.push(this.fb.group({
        // 付帯商品コード（商品名称）
        ftGoodsName: [{ value: dispFtiGoods.prdGoodsDisp, disabled: true }],
        // 適用開始日
        opeStartMonth: dispFlg ? [{
          value: this.timeApiService.convertStringToDate(dispFtiGoods.useStartDate),
          disabled: false
        }, Validators.required] : null,
        // 満了予定年月
        expScheduleMonth: dispFlg ? [{
          value: this.convertToYyyyMmAddHyphen(dispFtiGoods.ctrExpireDate),
          disabled: false
        }, Validators.required] : null,
        // 付帯契約の継続年数（長期割引でない場合はnullを設定）
        continuYears: dispFlg ? [{ value: dispFtiGoods.duration, disabled: false }, Validators.required] : null,
        // 商品コード
        ftGoodsCode: [{ value: dispFtiGoods.goodsCode, disabled: false }],
        // 長期使用契約項目表示フラグ
        dispChokiItem: [{ value: dispFlg, disabled: false }],
      }));
    });
    // 変更検出を行い、ビューとデータの整合性を確保
    this.cdr.detectChanges();
  }

  get items(): UntypedFormArray {
    return this.contModInputChildForm.get('items') as UntypedFormArray;
  }

  /**
   * 購読を停止する処理
   * @memberof Sgkb980dInputComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.parentForm.clearValidators();
    this.parentForm.updateValueAndValidity();
    this.parentForm.removeControl('contModInputChildForm');
  }

  /**
   * 登録ボタン押下処理
   * @memberof Sgkb980dInputComponent
   */
  onClickRegist(): void {

    this.usedsgkb981aService.insertCustomer(this.contModInputChildForm.getRawValue())
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        if (response != null) {
          // 登録完了画面情報設定
          this.completeDataService.completeData = {
            title: '契約修正完了',
            message: '契約を修正しました',
            next: '',
            koumokuList: [
              { label: '契約お客さま番号', val: response.syuseiInfo.firstSrvctrNo },
            ],
          };
          // 登録完了画面遷移
          this.router.navigate(['/sgkz003d']);
        }
        else {
          console.log('SGKB981A Error.');
        }
      })
  }

  /**
   * 閉じるボタン押下処理
   * @memberof Sgkb980dInputComponent
   */
  onClickClose(): void {
    window.close();
  }

  /**
   * 年月項目をyyyy年MM月形式に変換する
   * @memberof Sgkb980dInputComponent
   */
  convertToYyyyMm(date: string): string {
    let result = '';
    if (date && date != '') {
      const yyyy = date.slice(0, 4);
      const MM = date.slice(4, 6);
      result = yyyy + '年' + MM + '月';
    }
    return result;
  }

  /**
   * 年月項目をyyyy-MM形式に変換する
   * @memberof Sgkb980dInputComponent
   */
  convertToYyyyMmAddHyphen(date: string): string {
    let result = '';
    if (date && date != '') {
      const yyyy = date.slice(0, 4);
      const MM = date.slice(4, 6);
      result = yyyy + '-' + MM;
    }
    return result;
  }

  /**
   * フォーカスアウト時のカンマ編集
   * @memberof Sgkb980dInputComponent
   */
  onBlurNumberComma(targetItem: string): void {
    if (this.contModInputChildForm.controls[targetItem].value != null) {
      let targetMoney: string = this.contModInputChildForm.controls[targetItem].value.toString();
      let commaMoney: string = this.moneyFormatService.formatMoney(targetMoney);
      // カンマの数取得
      let commaArray: string[] = commaMoney.match(/,/g);
      let commaCount: number = 0;
      if (commaArray != null) {
        commaCount = commaArray.length
      }
      // カンマの数と元々の最大桁数をmaxlengthに設定
      if (targetItem === 'coolAbility') {
        this.numberCommaMaxLength1 = this.constNumberCommaMaxLength1 + commaCount;
      }
      if (targetItem === 'generatCapacity') {
        this.numberCommaMaxLength2 = this.constNumberCommaMaxLength2 + commaCount;
      }
      if (targetItem === 'preRatedInputValue') {
        this.numberCommaMaxLength3 = this.constNumberCommaMaxLength3 + commaCount;
      }
      setTimeout(() => {
        this.contModInputChildForm.controls[targetItem].setValue(commaMoney);
      }, 1);
    }
  }

  /**
   * フォーカスイン時のカンマ編集
   * @memberof Sgkb980dInputComponent
   */
  onFocusNumberComma(targetItem: string): void {
    let targetMoney: string = this.contModInputChildForm.controls[targetItem].value;
    let noCommatMoney: string = this.moneyFormatService.reformatMoney(targetMoney);
    if (targetItem === 'coolAbility') {
      this.numberCommaMaxLength1 = this.constNumberCommaMaxLength1;
    }
    if (targetItem === 'generatCapacity') {
      this.numberCommaMaxLength2 = this.constNumberCommaMaxLength2;
    }
    if (targetItem === 'preRatedInputValue') {
      this.numberCommaMaxLength3 = this.constNumberCommaMaxLength3;
    }
    this.contModInputChildForm.controls[targetItem].setValue(noCommatMoney);
  }
  /**
  * 部署情報検索のリクエスト設定
  * @memberof Sgkb701dSearchConditionComponent
  * @param comGrpCd
  * @param comCd
  */
  setSgkb991aRequest(comGrpCd: string, comCd: string): Sgkb991aRequest {
    // 部署情報検索リクエストを作成
    const sgkb991aRequest: Sgkb991aRequest = {
      companyInfo: {
        // 会社グループコード
        companyGroupCode: comGrpCd,
        // 会社コード
        companyCode: comCd
      }
    }
    return sgkb991aRequest;
  }

  /**
   * 社員情報検索のリクエスト設定
   * @memberof Sgkb701dSearchConditionComponent
   */
  setSgkb992aRequest(sosikiId: string): Sgkb992aRequest {
    // 社員情報検索リクエストを作成
    const sgkb992aRequest: Sgkb992aRequest = {
      bushoInfo: {
        // 部署コード
        bushoCode: sosikiId,
      }
    }
    return sgkb992aRequest;
  }

  /**
   * 部署情報取得API実行
   * @param comGrpCd
   * @param comCd
   */
  executeSgkb991A(comGrpCd: string, comCd: string, sosikiId: string): void {
    // 部署情報取得レスポンスを取得
    this.usedSgkb991aService.searchContractor(this.setSgkb991aRequest(comGrpCd, comCd))
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.sgkb991aResponseCommon = response.responseCommon;
        this.bushoInfoList = response.bushoInfoList;

        /** 契約担当部署リスト情報 */
        this.bushoInfoList.forEach(data => {
          const select: SelectBox = { value: data.bushoCode, viewValue: data.departmentName };
          this.contractDepartmentList.push(select);
        })
        this.contModInputChildForm.controls['contractDepartmentCategory'].setValue(sosikiId)
        // 変更検出を行い、ビューとデータの整合性を確保
        this.cdr.detectChanges();
      })
  }

  /**
   * 社員情報取得API実行
   * @param comGrpCd
   * @param comCd
   */
  executeSgkb992A(sosikiId: string, tantoPrivateid: string): void {
    this.usedSgkb992aService.searchContractor(this.setSgkb992aRequest(sosikiId))
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.sgkb992aResponseCommon = response.responseCommon;
        this.staffInfoList = response.staffInfoList;
        /** 契約担当者リスト情報 */
        this.staffInfoList.forEach(data => {
          const select: SelectBox = { value: data.staffCode, viewValue: data.staffName };
          this.contractManagerList.push(select)
        });
        this.contModInputChildForm.controls['contractManagerCategory'].setValue(tantoPrivateid)
        // 変更検出を行い、ビューとデータの整合性を確保
        this.cdr.detectChanges();
      })
  }

  /**
   * 契約担当者リスト表示処理
   * @memberof Sgkb701dSearchConditionComponent
   */
  onChangeSelectBox(event: any): void {
    // 社員情報取得レスポンスを取得
    this.bushoCode = event.value
    this.usedSgkb992aService.searchContractor(this.setSgkb992aRequest(this.bushoCode))
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.sgkb992aResponseCommon = response.responseCommon;
        this.staffInfoList = response.staffInfoList;
        this.contractManagerList = [];
        /** 契約担当者リスト情報 */
        this.staffInfoList.forEach(data => {
          this.contractManagerList = this.staffInfoList.map(data =>
          ({
            value: data.staffCode,
            viewValue: data.staffName
          }));
        });
      })
    // 検索後は何も選択されていない状態にする
    this.contModInputChildForm.controls['contractManagerCategory'].setValue(null)
  }
}
